export default __webpack_public_path__ + "caeaf88566cfe72e95c8bdce77aec496.png";